import { useState } from 'react';

const useCustomHook = () => {
  const [loadBtn, setLoadBtn] = useState(false);
  const [operationCode, setOperationCode] = useState(false);
  const [type, setType] = useState('branch'); // funder
  return {
    operationCode,
    setOperationCode,
    loadBtn,
    setLoadBtn,
    type,
    setType,
  };
};

export default useCustomHook;
